import baustein from "baustein";


const filteringClass = "lyst-main--filtering";

export default baustein.register("feed-main", {
    showFilteringOverlay: function() {
        this.el.classList.add(filteringClass);
    },

    hideFilteringOverlay: function() {
        this.el.classList.remove(filteringClass);
    },
});
